import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"

export enum CravingsAssets {

    BACKGROUND = "CravingsBACKGROUND",
    CHAIR = "CravingsCHAIR",
    CHAIR_ARMS = "CravingsCHAIR_ARMS",
    NIC_METER = "CravingsNIC_METER",
    RED_BAR = "CravingsRED_BAR",
    BLUE_BAR = "CravingsBLUE_BAR",
    NO_CIG = "CravingsNO_CIG",

    AUDIO = "PhysicalAUDIO",

    KID = "CravingsKID",
    CRAVINGS_HAT = "CravingsCRAVINGS_HAT",
}

export function loadAssets(game: Phaser.Game) {
    game.load.image(CravingsAssets.BACKGROUND, CCUtils.asset("addiction/cravings-and-withdrawal/background.png"))
    game.load.image(CravingsAssets.CHAIR, CCUtils.asset("addiction/cravings-and-withdrawal/chair.png"))
    game.load.image(CravingsAssets.CHAIR_ARMS, CCUtils.asset("addiction/cravings-and-withdrawal/chair-arms.png"))
    game.load.image(CravingsAssets.NIC_METER, CCUtils.asset("addiction/cravings-and-withdrawal/nic-meter.png"))
    game.load.image(CravingsAssets.RED_BAR, CCUtils.asset("addiction/cravings-and-withdrawal/red-bar.png"))
    game.load.image(CravingsAssets.BLUE_BAR, CCUtils.asset("addiction/cravings-and-withdrawal/blue-bar.png"))
    game.load.image(CravingsAssets.NO_CIG, CCUtils.asset("addiction/cravings-and-withdrawal/no-cig.png"))

    game.load.audio(CravingsAssets.AUDIO, CCUtils.asset("addiction/cravings-and-withdrawal/addiction-101-cravings-and-withdrawal.mp3"))

    game.load.spritesheet(CravingsAssets.KID, CCUtils.asset("addiction/cravings-and-withdrawal/cravings-kid.png"),
        300, 494)
    game.load.spritesheet(CravingsAssets.CRAVINGS_HAT, CCUtils.asset("addiction/cravings-and-withdrawal/cravings-hat.png"),
        346, 215)
}
